export default __webpack_public_path__ + "static/media/card.b054d477.gif";